import React, { Component } from 'react'
import { styles } from '../styles'
import withStyles from 'material-ui/styles/withStyles'
import withTheme from 'material-ui/styles/withTheme'
import Card, {CardContent, CardActions} from 'material-ui/Card'
import Grid from 'material-ui/Grid'
import {compose} from 'redux'
import {firebaseConnect} from 'react-redux-firebase'
import {personality, softskills, wp} from '../testPool'
import {testAnswer} from './action'
import {connect} from 'react-redux'
import Typography  from 'material-ui/Typography';

import { Divider } from 'material-ui'
import Button from 'material-ui/Button'
import { LinearProgress } from 'material-ui/Progress'
class OtherTestContainer extends Component {
    key=''
    test = {}
    answerText=['ไม่ตรงเลย', 'ไม่ค่อยตรง', 'ปานกลาง', 'ค่อนข้างตรง', 'ตรงมาก']
    max = 15
    constructor(props) {
        super(props)
        switch(this.props.profile.currentTest) {
            case 'personality':
                this.test = personality[this.props.profile.currentIndex]
                break
            case 'softskills':
                this.test = softskills[this.props.profile.currentIndex]
                break
            case 'wp':
                this.test = wp[this.props.profile.currentIndex]
                this.answerText = ['สนใจมาก','สนใจ','เฉยๆ','ไม่ค่อยสนใจ','ไม่สนใจเลย']
                break
            default:
                console.log('INVALID TESTTYPE')

        }
        this.key = Object.keys(this.test)[0]
    }
    componentWillReceiveProps() {
        switch(this.props.profile.currentTest) {
            case 'personality':
                this.test = personality[this.props.profile.currentIndex]
                break
            case 'softskills':
                this.test = softskills[this.props.profile.currentIndex]
                break
            case 'wp':
                this.test = wp[this.props.profile.currentIndex]
                this.answerText = ['สนใจมาก','สนใจ','เฉยๆ','ไม่ค่อยสนใจ','ไม่สนใจเลย']
                break
            default:
                console.log('INVALID TESTTYPE')

        }
        this.key = Object.keys(this.test)[0]
    }
    render() {
        return(
            <div>
                
                <Grid container justify='center' direction='column' style={{marginTop: "8px", flexGrow: 1, alignItems: 'center'}} spacing={0}>
                    <Grid item style={{margin: '8px'}}>
                        <Card elevation={4} style={{width: '350px'}}>
                            <CardContent style={{textAlign: 'center'}}>
                                <Typography variant="caption" >
                                    {this.props.profile.currentTest === 'personality'?
                                        'ส่วนที่ 2 - บุคลิกภาพ ':
                                            this.props.profile.currentTest==='softskills'?
                                                'ส่วนที่ 3 - การปฏิบัติงาน':
                                                    'ส่วนที่ 4 - ความสนใจ '
                                        
                                            }
                                </Typography>
                                <Typography variant="caption" >
                                    {this.props.profile.currentTest === 'personality'?
                                        'ข้อความต่อไปนี้ตรงกับบุคลิกของท่านเพียงใด':
                                            this.props.profile.currentTest==='softskills'?
                                                'ข้อความต่อไปนี้อธิบายการทำงานของท่านดีเพียงใด':
                                                    'ท่านสนใจที่จะทำหรือเรียนรู้กิจกรรมนี้เพียงใด'
                                        
                                            }
                                </Typography>
                            </CardContent>
                            <Divider/>
                            <CardActions style={{justifyContent: 'center', textAlign:'center', height: '100px'}}>
                                <Typography variant="headline" component="h3">
                                    {this.key}
                                </Typography>
                            </CardActions>
                        </Card><br/>
                        <Button 
                            onClick={()=> {
                                            this.props.dispatch(
                                                testAnswer(
                                                    this.props.auth.uid,
                                                    this.props.profile.currentTest,
                                                    this.props.profile.currentIndex,
                                                    this.key,
                                                    this.test[this.key].score[0],
                                                    this.test[this.key].trait
                                                )
                                            )
                                        }}
                            variant='raised' color='secondary' style={{width: '350px', marginTop: '8px'}} >{this.answerText[0]} 
                        </Button>
                        <br/>
                        <Button 
                            onClick={()=> {
                                            this.props.dispatch(
                                                testAnswer(
                                                    this.props.auth.uid,
                                                    this.props.profile.currentTest,
                                                    this.props.profile.currentIndex,
                                                    this.key,
                                                    this.test[this.key].score[1],
                                                    this.test[this.key].trait
                                                )
                                            )
                                        }}
                            variant='raised' color='secondary' style={{width: '350px', marginTop: '8px'}} >{this.answerText[1]} 
                        </Button><br/>
                        <Button 
                            onClick={()=> {
                                            this.props.dispatch(
                                                testAnswer(
                                                    this.props.auth.uid,
                                                    this.props.profile.currentTest,
                                                    this.props.profile.currentIndex,
                                                    this.key,
                                                    this.test[this.key].score[2],
                                                    this.test[this.key].trait
                                                )
                                            )
                                        }}
                            variant='raised' color='secondary' style={{width: '350px', marginTop: '8px'}} >{this.answerText[2]} 
                        </Button><br/>
                        <Button 
                            onClick={()=> {
                                            this.props.dispatch(
                                                testAnswer(
                                                    this.props.auth.uid,
                                                    this.props.profile.currentTest,
                                                    this.props.profile.currentIndex,
                                                    this.key,
                                                    this.test[this.key].score[3],
                                                    this.test[this.key].trait
                                                )
                                            )
                                        }}
                            variant='raised' color='secondary' style={{width: '350px', marginTop: '8px'}} >{this.answerText[3]} 
                        </Button><br/>
                        <Button 
                            onClick={()=> {
                                            this.props.dispatch(
                                                testAnswer(
                                                    this.props.auth.uid,
                                                    this.props.profile.currentTest,
                                                    this.props.profile.currentIndex,
                                                    this.key,
                                                    this.test[this.key].score[4],
                                                    this.test[this.key].trait
                                                )
                                            )
                                        }}
                            variant='raised' color='secondary' style={{width: '350px', marginTop: '8px'}} >{this.answerText[4]} 
                        </Button>
                        <br/><br/>
                        {
                            this.props.profile.currentTest === 'personality'?
                                    <div>
                                        <Typography style={{textAlign:'center'}}>
                                            {this.props.profile.currentIndex+1}/{this.max = 40}
                                        </Typography>
                                    </div>:
                                            this.props.profile==='softskills'?
                                            <div>
                                                <Typography style={{textAlign:'center'}}>
                                                    {this.props.profile.currentIndex+1}/{this.max = 28}
                                                </Typography>
                                            </div>:
                                            <div>
                                                <Typography style={{textAlign:'center'}}>
                                                    {this.props.profile.currentIndex+1}/{this.max = 30}
                                                </Typography>
                                            </div>
                                        
                                            
                        }
                        <LinearProgress style={{width: '350px'}} color="secondary" variant="determinate" value={((this.props.profile.currentIndex+1)/this.max)*100} />
                    </Grid>
                    
                </Grid>
            </div>
        )
    }
}

export default compose(firebaseConnect(),withTheme(),withStyles(styles),
    connect(({firebase: {auth}}) => ({auth})))(OtherTestContainer)


// WEBPACK FOOTER //
// ./src/test/OtherTestContainer.js